<div id="reportingDashboard" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel"
      (downloadEvent)="downloadReport()"  [showClone]=true titleClone="Copy Download Link" (cloneEvent)="copyNCEOrdersReportLink()"></child-header>
    <div class="inner-subBlock-wrapper">

      <div id="basic-info-wrapper">
        <div style="margin-bottom: 20px;" class="row filter-wrapper">
          <div class="col searchInput-position">
            <div class="searchInputGroup" style="margin-left: 30px;">
              <div class="searchIcon">
                <img src="../../images/new_ui/filter.png">
              </div>
              <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="loadContent && NCEOrders.length > 0 && !hasEmptyFilterResult">
        <div class="shared-outer-wrapper table-header-allign" *ngIf="NCEOrders?.length">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead>
              <tr class="row">
                <th class="col" mat-sort-header="action">ACTION</th>
                <th class="col align-left" style="max-width: 12%;" mat-sort-header="qty">QTY</th>
                <th class="col align-center" style="max-width: 18%;" mat-sort-header="unitprice">UNIT PRICE</th>
                <th class="col align-right" style="max-width: 8%;" mat-sort-header="rrp">RRP</th>
                <th class="col align-right" style="max-width: 11%;" mat-sort-header="extprice">EXT PRICE</th>
                <th class="col align-right" style="max-width: 10%;" mat-sort-header="extrrp">EXT RRP</th>
                <th class="col" style="max-width: 11%;" mat-sort-header="user">USER</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="shared-outer-wrapper child-body subscription-rp" *ngIf="NCEOrders?.length">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead hidden="true">
              <tr class="row">
                <th class="col" mat-sort-header="action">ACTION</th>
                <th class="col align-left" style="max-width: 12%;" mat-sort-header="qty">QTY</th>
                <th class="col align-center" style="max-width: 18%;" mat-sort-header="unitprice">UNIT PRICE</th>
                <th class="col align-right" style="max-width: 8%;" mat-sort-header="rrp">RRP</th>
                <th class="col align-right" style="max-width: 11%;" mat-sort-header="extprice">EXT PRICE</th>
                <th class="col align-right" style="max-width: 10%;" mat-sort-header="extrrp">EXT RRP</th>
                <th class="col" style="max-width: 11%;" mat-sort-header="user">USER</th>
              </tr>
            </thead>
           <tbody class="scrollable-table-body">
              <ng-container
              *ngFor="let order of sortedData | TableFilterMultiple:['tenantGuid', 'tenantName','subscriptionOfferName','subscriptionGuid','dateCompleted'] : searchField;">
                <tr class="row">
            <tbody class="nested-body">
              <tr class="row no-border no-hover">
                <td class="col">
                  <span class="infoSection-title-bold">Tenant GUID:&nbsp;</span>
                  <span class="infoSection-content-uppercase"></span>
                  <span class="infoSection-content-uppercase">{{order?.tenantGuid}}</span><br>
                  <span class="infoSection-title-bold">Tenant Name:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.tenantName}}</span><br>
                  <span class="infoSection-title-bold">Subscription Offer Name:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.subscriptionOfferName}}</span><br>
                  <span class="infoSection-title-bold">Subscription Guid:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.subscriptionGuid}}</span><br>
                  <span class="infoSection-title-bold">Date Added:&nbsp;</span>
                  <span class="infoSection-content-uppercase">{{order?.dateCompleted}}</span>
                </td>
              </tr>
              <ng-container>
                <tr class="row no-border no-hover">                 
                  <td class="col-md">{{order?.action}}</td>
                  <td class="col-md align-right" style="max-width: 17%;">{{order?.changeQuantity}}</td>
                  <td class="col-md align-center">{{order?.unitPrice | number: '1.2-2' }}</td>
                  <td class="col-md align-right" style="max-width: 8%;">{{order?.rrp | number: '1.2-2' }}</td>
                  <td class="col-md align-right" style="max-width: 12%;">{{order?.ext_Price | number: '1.2-2' }}</td>
                  <td class="col-md align-right" style="max-width: 12%;">{{order?.ext_RRP | number: '1.2-2' }}</td>
                  <td class="col-md" style="max-width: 11%;">{{order?.user}}</td>             
                </tr>
              </ng-container>
            </tbody>
            </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <ng-container *ngIf="loadContent && hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
          <button (click)="filterReset()" class="button button-red button-large">Try again</button>
          <div class="noResult-feedback">Send feedback</div>
        </div>
        <div class="top-divider"></div>
      </ng-container>

      <div class="inner-subBlock-wrapper" *ngIf="loadContent && !NCEOrders.length  && !hasEmptyFilterResult">
        <div class="noData-wrapper">
          <div>
            <img src="../../images/new_ui/no-subscription.png">
          </div>
          <label class="noData-label">
            WE COULDN'T FIND ANY NCE ORDERS
          </label>
          <br />

        </div>
      </div>

    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>
<router-outlet></router-outlet>